import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconAudio16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="audio">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 13.0042V2.99569L6.05297 5.20202C5.36108 5.72002 4.52002 5.99997 3.65571 5.99997H2V9.99997H3.65571C4.52002 9.99997 5.36108 10.2799 6.05297 10.7979L9 13.0042ZM2 3.99997C0.89543 3.99997 0 4.8954 0 5.99997V9.99997C0 11.1045 0.895432 12 2 12H3.65571C4.08787 12 4.5084 12.1399 4.85434 12.3989L7.80137 14.6053C9.12006 15.5925 11 14.6516 11 13.0042V2.99569C11 1.34839 9.12006 0.407413 7.80137 1.39467L4.85434 3.601C4.5084 3.85999 4.08787 3.99997 3.65571 3.99997H2Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.1684 3.44472C12.4751 2.98543 13.0961 2.86175 13.5554 3.16847C15.0521 4.16803 16 5.98587 16 8.00008C16 10.0143 15.0521 11.8321 13.5554 12.8317C13.0961 13.1384 12.4751 13.0147 12.1684 12.5554C11.8617 12.0961 11.9854 11.4752 12.4446 11.1685C13.3391 10.5712 14 9.40432 14 8.00008C14 6.59583 13.3391 5.429 12.4446 4.83169C11.9854 4.52497 11.8617 3.904 12.1684 3.44472Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconAudio24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="audio">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 18.503V5.49666L6.98346 8.44756C6.36876 8.80915 5.66855 8.99982 4.95538 8.99982H2V14.9998H4.95538C5.66855 14.9998 6.36876 15.1905 6.98346 15.5521L12 18.503ZM2 6.99982C0.895431 6.99982 0 7.89525 0 8.99982V14.9998C0 16.1044 0.895431 16.9998 2 16.9998H4.95538C5.31197 16.9998 5.66207 17.0952 5.96942 17.276L10.986 20.2269C12.3192 21.0111 14 20.0498 14 18.503V5.49666C14 3.94983 12.3192 2.98851 10.986 3.77279L5.96942 6.72369C5.66207 6.90449 5.31197 6.99982 4.95538 6.99982H2Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.9656 3.39236C16.7185 3.92875 16.9973 4.55682 17.5273 4.81755C20.1767 6.12117 22 8.84765 22 12C22 15.1523 20.1767 17.8788 17.5273 19.1824C16.9973 19.4431 16.7185 20.0712 16.9656 20.6076C17.1795 21.0719 17.715 21.3013 18.1793 21.0874C21.6151 19.5047 24 16.0308 24 12C24 7.9691 21.6151 4.49526 18.1793 2.91253C17.715 2.69862 17.1795 2.92801 16.9656 3.39236Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.1344 8.03457C16.4109 7.55651 17.0227 7.39314 17.5007 7.66969C18.9926 8.5327 20 10.1482 20 12.0002C20 13.8521 18.9926 15.4676 17.5007 16.3306C17.0227 16.6072 16.4109 16.4438 16.1344 15.9658C15.8578 15.4877 16.0212 14.876 16.4993 14.5994C17.3986 14.0792 18 13.1093 18 12.0002C18 10.891 17.3986 9.92112 16.4993 9.4009C16.0212 9.12435 15.8578 8.51263 16.1344 8.03457Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
